import * as React from 'react';
import { SpinnerPage } from '@common/components';
import { LocalForm, Control, Errors } from 'react-redux-form';
import { hasValue, isValidEmail, getDefaultErrorMessages } from '@common/validators';

export interface DocumentResendComponentProperties {
  readonly emailHistoryId: number;
  readonly entityId?: number;
  readonly emailAddress?: string;

  readonly resendEmail: (
    emailHistoryId: number,
    entityId?: number,
    emailAddress?: string,
    isFailedEmail?: boolean
  ) => void;
}

interface ResendEmailState {
  isLoading: boolean;
  newEmail: boolean;
}

export class DocumentResendComponent extends React.Component<DocumentResendComponentProperties, ResendEmailState> {
  constructor(props: DocumentResendComponentProperties) {
    super(props);
    this.state = {
      isLoading: false,
      newEmail: false
    };
  }

  resendEmail(email?: string) {
    this.setState({ isLoading: true });
    this.props.resendEmail(this.props.emailHistoryId, this.props.entityId, email);
  }

  render() {
    if (this.state.isLoading) {
      return <SpinnerPage />;
    }
    if (this.state.newEmail) {
      return (
        <>
          <LocalForm onSubmit={this.handleSubmit} hideNativeErrors={true}>
            <div className="form-control">
              <label>New Email Address</label>
              <div className="row">
                <div className="col-md-9">
                  <Control.text validators={{ required: hasValue, invalidUserName: isValidEmail }} model=".email" />
                  <Errors
                    className="error"
                    model=".email"
                    show={{ touched: true, focus: false }}
                    messages={getDefaultErrorMessages({ invalidUserName: 'Invalid Email' })}
                  />
                </div>
                <div className="col-md-3">
                  <button className="btn btn-primary" type="submit">
                    Send
                  </button>
                </div>
              </div>
            </div>
          </LocalForm>
        </>
      );
    }
    return (
      <>
        <div className="row mb-10">
          <h2>Send to {this.props.emailAddress} or enter a new address?</h2>
        </div>
        <div className="row mt-25">
          <div className="col-md-6 text-right">
            <button
              className="btn btn-primary"
              type="button"
              onClick={() => {
                this.resendEmail();
              }}
            >
              Send to Same Address
            </button>
          </div>
          <div className="col-md-6">
            <button
              className="btn btn-primary"
              type="button"
              onClick={() => {
                this.setState({ newEmail: true });
              }}
            >
              Send to New Address
            </button>
          </div>
        </div>
      </>
    );
  }

  private handleSubmit = (formData: any): void => {
    this.resendEmail(formData.email);
  };
}



// WEBPACK FOOTER //
// ./src/document-history/_components/document-resend/document-resend.component.tsx